export const BUILDING_VISIBLE: number = 0x0;
export const BUILDING_HIDDEN_BY_REPLACEMENT: number = 0x1;
export const BUILDING_HIDDEN_BY_TILE_BORDER_DEDUPLICATION: number = 0x2;
export const BUILDING_HIDDEN_WITH_INCOMPLETE_PARTS: number = 0x4;
